import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { SEO } from '../seo/SEO';

export const TermsAndConditions: React.FC = () => {
  return (
    <>
      <SEO 
        title="Terms and Conditions | Banga.ai"
        description="Read our terms and conditions to understand your rights and responsibilities when using Banga.ai"
      />
      
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8 transition-colors">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>

          <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 md:p-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Terms and Conditions</h1>
            
            <div className="prose dark:prose-invert max-w-none">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">A. Introduction</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                By viewing or using Predictions and Betting tips on Banga.ai website or any of our affiliate sites, pages, 
                accounts and/or signing up on the website, you agree to be bound by and to comply with:
              </p>
              <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 mb-6">
                <li>These Terms and Conditions</li>
                <li>Our Privacy Policy</li>
                <li>Our Cookies Policy</li>
                <li>The Rules applicable to our betting or gaming products</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">B. Your Account</h2>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mt-6 mb-3">Age Restriction</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                All users must be over 18+ years to sign up with Banga.ai. We reserve the right to ask for proof of age 
                from any user and suspend their account until satisfactory documentation is provided.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">C. Predictions and Picks</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Our experts provide their best predictions with reasonable guarantee by ensuring they reduce risks to their 
                lowest possible minimum. We are not responsible for failing outcomes of matches as all predictions and match 
                analysis end before the match is played and final outcomes are decided on the pitch.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">D. Our Liability</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Banga.ai does not accept any liability for any damages, liabilities or losses which are deemed or alleged 
                to have arisen out of or in connection with services, picks and predictions on the Website or its affiliates.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-8 mb-4">Contact Information</h2>
              <div className="bg-gray-50 dark:bg-gray-700/50 p-4 rounded-lg">
                <p className="text-gray-700 dark:text-gray-300">
                  Tripple O Solutions<br />
                  35, Raufa Williams Street<br />
                  Off Adelabu Street, Surulere<br />
                  Lagos state, Nigeria
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};